<template>
  <div
    v-if="$login.can('analysts.view')"
    class="analysts-list"
  >
    <page-header header="Analysts">
      <router-link
        class="btn btn-primary"
        v-if="$login.can('analysts.create')"
        :to="{ name: 'analysts.create' }"
      >
        Add Analyst
      </router-link>
    </page-header>
    <search
      class="my-3"
      v-model="params.search"
    />

    <vue-good-table
      :columns="columns"
      :rows="analysts"
      styleClass="vgt-table"
      @on-row-click="({row}) => navigateToAnalyst(row)"
    />

    <pagination
      :data="pagination"
      :disabled="loading"
      @change-page="changePage"
    />
  </div>
</template>
<script>
import { VueGoodTable } from 'vue-good-table';

import axios from '@/axios'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'

const defaultPagination = () => {
  return {
    page: 1,
    full: true,
    search: null,
  }
}

export default {
  components: {
    VueGoodTable,
    Search,
    Pagination,
  },

  metaInfo () {
    return {
      title: 'Analysts',
    }
  },

  data () {
    return {
      analysts: [],
      channel: null,
      params: defaultPagination(),
      pagination: null,
      editUser: null,
      loading: false,
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Title',
          field: 'job_title',
        },
        {
          label: 'Phone',
          field: 'user.phone',
        },
        {
          label: 'Channel',
          field: 'channel.name',
        },
      ],
    }
  },

  activated () {
    this.getData()
  },

  mounted () {
    this.getData()
  },

  watch: {
    params: {
      deep: true,
      handler () {
        this.getData()
      },
    },
  },

  methods: {
    getData () {
      this.loading = true
      axios.get('/analysts/', {params: this.params}).then(({data}) => {
        this.analysts = data.data
        this.pagination = data.meta
        this.loading = false
      })
    },
    navigateToAnalyst ({id}) {
      this.$router.push({name: 'analysts.view', params: {analystId: id}})
    },

    changePage (page) {
      this.params.page = page
    },
  },
}
</script>
